/**
 * RoundTo
 *
 * Module that rounds a given time to the nearest quarter hour
 *
 * @return {string}
 */

OT.createNS('OT.Search.Helpers.RoundTimeTo');

OT.Search.Helpers.RoundTimeTo = (function() {

    var quarterHour = function(time) {
        time = OT.Search.Helpers.convertTimeTo24Hour(time);

        var mins = time.split(':');

        if(+mins[1] > 45) {
            mins[0]++;
            mins[1] = '00';
        } else if(+mins[1] > 30) {
            mins[1] = '45';
        } else if(+mins[1] > 15) {
            mins[1] = '30';
        } else {
            mins[1] = '15';
        }

        return moment(mins[0] +':'+ mins[1], 'H:mm').format(Resources.Strings.TimeFormatJS);
    };

    var halfHour = function (time) {
        time = OT.Search.Helpers.convertTimeTo24Hour(time);

        var mins = time.split(':');

        if(mins[1] > 30) {
            mins[0]++;
            mins[1] = '00';
        } else {
            mins[1] = '30';
        }

        return moment(mins[0] + ':' + mins[1], 'H:mm').format(Resources.Strings.TimeFormatJS);
    };

    return {
        quarterHour: quarterHour,
        halfHour: halfHour
    };

})();